module.exports = __webpack_public_path__ + "img/dzzzcx.b1148ce3.png";